import { render, staticRenderFns } from "./departmentsAndOfficesAddPages.vue?vue&type=template&id=13c9e5f4&scoped=true&"
import script from "./departmentsAndOfficesAddPages.vue?vue&type=script&lang=ts&"
export * from "./departmentsAndOfficesAddPages.vue?vue&type=script&lang=ts&"
import style0 from "./departmentsAndOfficesAddPages.vue?vue&type=style&index=0&id=13c9e5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9e5f4",
  null
  
)

export default component.exports